import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Detect react-snap prerender (skip analytics during static prerender at build time)
const isPrerender = typeof navigator !== 'undefined' && /ReactSnap/i.test(navigator.userAgent);

if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_SENTRY_DSN && !isPrerender) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: process.env.NODE_ENV,
    // Only report errors from our own pages. Copies of the site served through web proxies
    // (e.g. hideproxy.me) rewrite our JS and produce noise like "Unexpected token '<'".
    allowUrls: [/^https?:\/\/([a-z0-9-]+\.)*realtimerepairs\.com\//i],
  });
}

if (process.env.NODE_ENV === 'production' && process.env.REACT_APP_POSTHOG_KEY && !isPrerender) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    disable_session_recording: true,
  });
}

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Use hydrateRoot if pre-rendered (react-snap), createRoot otherwise
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app, {
    onRecoverableError: (error) => {
      // Suppress hydration mismatch warnings in production
      if (process.env.NODE_ENV === 'production') return;
      console.error(error);
    }
  });
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
